var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapModal',{attrs:{"modalNode":_vm.modalNode,"submitData":_vm.submitData,"title":_vm.videoCategoryRenew.title,"id":_vm.videoCategoryRenew.id,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }